module.exports = __webpack_public_path__ + "static/media/lei03.1cb87683.jpg";